<template>
    <div class="categories" :class="{'opacity': loading}">
        <swiper :options="swiperOption"
                ref="mySwiper">
            <swiper-slide v-for="(icon, index) in menuList"
                          :key="index"
                          class="cursorPoint">
                <div class="rounded-circle d-flex align-items-center justify-content-center mx-auto menuIcon "
                     :style="{
                        backgroundColor:
                            active === icon.value ? '#5BAED3' : '#F0FBFF',
                    }"
                     :data-ga-element="`${gaInfo}${icon.label}`"
                     @click="setCategory(icon.value)">
                    <img :src="icon.imgActiveUrl"
                         :alt="icon.alt"
                         :data-ga-element="`${gaInfo}${icon.label}`"
                         v-if="active === icon.value" />
                    <img :src="icon.imgUrl"
                         :alt="icon.alt"
                         :data-ga-element="`${gaInfo}${icon.label}`"
                         v-else />
                </div>
                <h3 class="text-center mt-1 text-nowrap title"
                    :style="{
                        color:
                            active === icon.value ? '#5BAED3' : '#333',
                    }"
                    :data-ga-element="`${gaInfo}${icon.label}`"
                    @click="setCategory(icon.value)">
                    {{ icon.label }}
                </h3>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    name: 'Categories',
    components: {
        swiper,
        swiperSlide,
    },
    props: {
        gaData: { type: String, default: '' },
        active: { type: String, default: '' },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            zone: '分類按鈕-',
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 5,
                freeMode: true,
            },
            menuList: this.$store.state.menuList
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
        gaInfo() {
            return `${this.gaData}|${this.zone}`;
        },
    },
    methods: {
        setCategory(val) {
            if (!this.loading) {
                this.active !== val && this.$emit('getCategory', val);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.categories {
    &.opacity {
        opacity: 0.7;
    }
    .menuIcon {
        width: 75px;
        height: 75px;
    }
    .title {
        font-size: 1rem;
        font-weight: normal;
    }
    ::v-deep {
        .swiper-slide {
            width: 17%;
            min-width: 90px;
            max-width: 145px;
        }

        .swiper-wrapper {
            @media (min-width: 390px) {
                justify-content: center;
            }
        }
    }
}
</style>
